const pageName = `{% if template.suffix == blank  %}{% if template.name == 'index' %}Homepage{% else %}{{ template.name }}{% endif %}{% else %}{{ template.suffix }}{% endif %}`;
function pushToDataLayer(eventName, additionalData = {}) {
  const eventData = {
    event: eventName,
    ...additionalData,
  };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventData);
}
document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (event) {
    const callButton =
      event.target.closest(".call-button_header .btn-contact-url") ||
      event.target.closest(".info-contact a");

    const chatContainer =
      event.target.closest("#mobile-chat-container") ||
      event.target.closest("#new_live_chat") ||
      event.target.closest(".info-contact img") || event.target.closest(".chat-text");

    const banner = event.target.closest(".owl-item a");
    const wishlistIcon = event.target.closest(".wkh-button.wk-selected");
    const writeReviewButton = event.target.closest("#leaveReviewBtn");
    const submitReviewButton = event.target.closest("button.review-btn");
    const menuItem = event.target.closest("summary.header__menu-item, a.header__menu-item");
    const menuDrawer = event.target.closest(".menu-drawer__menu");
    const newsletterButton = event.target.closest(".button-newsletter button#Subscribe");

    if (callButton) {
      const eventName = "Top Header - Customer Care Number";
      const eventData = {
        content_group: pageName,
      };
      pushToDataLayer(eventName, eventData);
      console.log(eventName, eventData)
      Shopify.analytics.publish(eventName, eventData);
    }

    let name = document.querySelector('.newsletter-form__field-wrapper [name="contact[first_name]"]').value;
    let email = document.querySelector('.newsletter-form__field-wrapper [name="contact[email]"]').value;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (newsletterButton && name !== "" && email !== "" && emailPattern.test(email)) {
      const eventName = "newsletter_click";
      const eventData = {
        content_group: pageName,
        section_name: "footer newsletter",
        newsletter_click_text: "Join Our Community",
      };

      pushToDataLayer(eventName, eventData);
            console.log(eventName, eventData)

      Shopify.analytics.publish(eventName, eventData);
    }

    if (chatContainer) {
      const eventName = "Top Header - Customer Care Chat";
      const eventData = {
        content_group: pageName,
      };
      pushToDataLayer(eventName, eventData);
      Shopify.analytics.publish(eventName, eventData);
    }
 

    if (wishlistIcon) {
      const sku = wishlistIcon.getAttribute("data-sku");
      const prodName = wishlistIcon.getAttribute("data-prod_name");
      const currency = wishlistIcon.getAttribute("data-currecny_name");
      const brand = wishlistIcon.getAttribute("data-brnad");
      let category2 = "";
      let category3 = "";
      const categorymain = wishlistIcon.getAttribute("data-item_category2");
      if (categorymain) {
        category2 = wishlistIcon.getAttribute("data-item_category2");
        category3 = wishlistIcon.getAttribute("data-item_category3");
      } else {
        category2 = wishlistIcon.getAttribute("data-item_category3");
        category3 = "";
      }
      const price = wishlistIcon.getAttribute("data-price");
      const masterId = wishlistIcon.getAttribute("data-master_id");
      const eventName = "add_to_wishlist";
      const eventData = {
        ecommerce: {
          items: [
            {
              item_id: sku,
              item_name: prodName,
              item_category1: brand,
              item_category2: category2,
              item_category3: category3,
              price: price ? price : 0,
              currency: currency,
              prod_master_id: masterId,
              quantity: 1,
            },
          ],
        },
      };
      pushToDataLayer(eventName, eventData);
      console.log(eventName, eventData)
      Shopify.analytics.publish(eventName, eventData);
    }

    if (writeReviewButton) {
      const sectionName = "Write a Review";
      const eventName = "Review";
      const eventData = {
        section_name: sectionName,
        content_group: pageName,
      };

      pushToDataLayer(eventName, eventData);
      Shopify.analytics.publish(eventName, eventData);
    }

    const firstName = document?.querySelector("#review-form-popup #firstName")?.value.trim();
    const lastName = document?.querySelector("#review-form-popup #lastName")?.value.trim();
    const reviewEmail = document?.querySelector("#review-form-popup #ContactForm-email")?.value.trim();
    const feedback = document?.querySelector("#review-form-popup #reviewMessage")?.value.trim();

    if (submitReviewButton && firstName !== "" && lastName !== "" && reviewEmail !== "" && emailPattern.test(reviewEmail) && feedback !== "") {

      const sectionName = "Submit Review";
      const eventName = "Review";
      const eventData = {
        section_name: sectionName,
        content_group: pageName,
      };
      pushToDataLayer(eventName, eventData);
      Shopify.analytics.publish(eventName, eventData);
    }

    if (menuItem) {
      let clickText = "";
      let clickUrl = "";

      if (menuItem.tagName === "SUMMARY") {
        const anchor = menuItem.querySelector("a");
        if (anchor) {
          const titleMegaMenu = anchor.querySelector(".title-mega-menu");
          clickText = titleMegaMenu
            ? titleMegaMenu.textContent.trim()
            : anchor.textContent.trim();
          clickUrl = anchor.href;
        }
      } else if (menuItem.tagName === "A") {
        const titleMegaMenu = menuItem.querySelector(".title-mega-menu");
        clickText = titleMegaMenu
          ? titleMegaMenu.textContent.trim()
          : menuItem.textContent.trim();
        clickUrl = menuItem.href;
      }

      const eventName = "top_menu_header_click";
      const eventData = {
        event: eventName,
        content_group: pageName, // Fallback for content group
        top_menu_header_click_text: clickText,
        top_menu_header_click_url: clickUrl,
      };
      pushToDataLayer(eventName, eventData);
      console.log(eventName, eventData)
      if (typeof Shopify !== "undefined" && Shopify.analytics) {
        Shopify.analytics.publish(eventName, eventData);
      }
    }

    if (menuDrawer) {
      const clickedItem = event.target;

      if (
        clickedItem &&
        (clickedItem.tagName.toLowerCase() === "summary" ||
          (clickedItem.classList.contains("menu-drawer__menu-item") &&
            clickedItem.classList.contains("link--text")))
      ) {
        event.preventDefault();
        let menuText = "";
        let menuUrl = "";

        if (clickedItem.tagName.toLowerCase() === "summary") {
          const link = clickedItem.querySelector("a");
          if (link) {
            menuText = link.textContent.trim();
            menuUrl = link.href;
          }
        } else if (
          clickedItem.classList.contains("menu-drawer__menu-item") &&
          clickedItem.classList.contains("link--text")
        ) {
          menuText = clickedItem.textContent.trim();
          menuUrl = clickedItem.href;
        }
         if(menuDrawer) {
           const eventName = "top_menu_header_click";
          const eventData = {
             content_group: pageName, // Content group for tracking context
              mobile_menu_item_click_text: menuText,
              mobile_menu_item_click_url: menuUrl,
          };
           pushToDataLayer(eventName, eventData);
                 console.log(eventName, eventData)
            Shopify.analytics.publish(eventName, eventData);
         }
          
        window.location.href = menuUrl;
      }
    }
  });

  document.querySelectorAll(".owl-item a").forEach((link) => {
    link.addEventListener("click", (event) => {
      const img = link.querySelector("img");

      if (img) {
        const src = img.src;
        const bannerNameMatch = src.match(/\/([^/?]+)\.webp/);
        const bannerName = bannerNameMatch ? bannerNameMatch[1] : "Unknown";

        const eventName = "HomePage Banners";
        const bannerURL = link.href || "Unknown URL";

        const eventData = {
          HomePage_BannerName: bannerName,
          HomePage_BannerURL: bannerURL,
        };

        pushToDataLayer(eventName, eventData);
        console.log(eventName, eventData)
        Shopify.analytics.publish(eventName, eventData);
      } 
    }); 
  });
});


class ReviewTracker {
  constructor() {
    this.init();
  }
  
  init() {
    // Method 1: Event delegation
    this.setupEventDelegation();
    
    // Method 2: Mutation observer as backup
    this.setupMutationObserver();
    
    // Method 3: Periodic check
    this.setupPeriodicCheck();
  }
  
  setupEventDelegation() {
    document.addEventListener('click', (event) => {
      if (this.isReviewSubmitButton(event.target)) {
        this.trackReviewSubmission();
      }
    });
  }
  
  setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        for (let node of mutation.addedNodes) {
          if (node.nodeType === 1 && this.isReviewWidget(node)) {
            this.attachDirectHandler();
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  
  setupPeriodicCheck() {
    // Check every 2 seconds for first 30 seconds
    let checks = 0;
    const interval = setInterval(() => {
      if (this.attachDirectHandler() || checks > 15) {
        clearInterval(interval);
      }
      checks++;
    }, 2000);
  }
  
  isReviewSubmitButton(element) {
    return element.classList.contains('AirReviews-Button') && 
    element.closest('.AirReviews-ModalSubmit__Actions');
  }
  
  isReviewWidget(element) {
    return element.classList.contains('AirReviews-ModalSubmit__Actions') || 
    element.querySelector('.AirReviews-ModalSubmit__Actions');
  }
  
  attachDirectHandler() {
    const submitBtn = document.querySelector('.AirReviews-ModalSubmit__Actions .AirReviews-Button');
    
    if (submitBtn && !submitBtn.hasAttribute('data-gtm-direct')) {
      submitBtn.setAttribute('data-gtm-direct', 'true');
      submitBtn.addEventListener('click', () => {
        this.trackReviewSubmission();
      });
      return true;
    }
    return false;
  }

  getSelectedStarCount() {
    const paths = document.querySelectorAll('.AirReviews-Modal__Content-Container .AirReviews-Blocks__ActionRate svg path');
    let count = 0;
    
    paths.forEach(path => {
        // Get the computed style to handle both inline and CSS styles
        const computedStyle = window.getComputedStyle(path);
        const fill = computedStyle.fill;
        
        // Check if fill is not 'none' and not transparent
        if (fill && fill !== 'none' && fill !== 'transparent') {
            count++;
        }
    });
    return count;
  }
  
  trackReviewSubmission() {
    const reviewFeedback = document.querySelector('.AirReviews-Modal__Content-Container #review-content')?.value;
    const fileInput = document.querySelector('.AirReviews-Modal__Content-Container #file-upload');

    const selectedStars = this.getSelectedStarCount();

    if (reviewFeedback != '') {
      const pageName = window.dataLayerCustomData.pageName ? window.dataLayerCustomData.pageName : '';
      const firstName = window.dataLayerCustomData.customer.firstName ? window.dataLayerCustomData.customer.firstName : '';
      const LastName = window.dataLayerCustomData.customer.lastName ? window.dataLayerCustomData.customer.lastName : '';
      const email = window.dataLayerCustomData.customer.email ? window.dataLayerCustomData.customer.email : '';
  
      const eventName = "Submit Review";
      const eventData = {
        content_group: pageName,
        reviewer_first_name: firstName,
        reviewer_last_name: LastName,
        reviewer_email: email,
        rating: selectedStars,
        has_feedback: reviewFeedback,
      };
  
      pushToDataLayer(eventName, eventData);
      console.log(eventName, eventData)
      if (typeof Shopify !== "undefined" && Shopify.analytics) {
        Shopify.analytics.publish(eventName, eventData);
      }
    }

  }
} 

// Initialize the tracker
new ReviewTracker();


 // Cookies consent data
  document.addEventListener('click', (event) => {
    if (event.target.closest('#shopify-pc__prefs__header-save')) {
      const coockiePopupWrapper = event.target.closest('#shopify-pc__prefs__dialog');
      const analyticsInput = coockiePopupWrapper.querySelector('#shopify-pc__prefs__analytics-input');
      const marketingInput = coockiePopupWrapper.querySelector('#shopify-pc__prefs__marketing-input');

      // Check if the checkboxes are checked and set the result to "granted" or "denied"
      const analytics_granted = analyticsInput.checked ? 'granted' : 'denied';
      const ad_granted = marketingInput.checked ? 'granted' : 'denied';
      sendData(analytics_granted,ad_granted)
    }
    if (event.target.closest('#shopify-pc__prefs__header-decline') || event.target.closest('#shopify-pc__banner__btn-decline')) {
      sendData('denied','denied');
    }
    if (event.target.closest('#shopify-pc__prefs__header-accept') || event.target.closest('#shopify-pc__banner__btn-accept')) {
      sendData('granted','granted');
    }
  })
  function sendData(analytics_granted,ad_granted) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'shopify_clarity_consent_update',
      clarity_analytics_storage: analytics_granted,
      clarity_ad_storage: ad_granted
    });
  }